import React, { Fragment } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import { colors, Container, TextField } from "@material-ui/core";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import {
    Autocomplete,
    ToggleButton,
    ToggleButtonGroup,
} from "@material-ui/lab";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import {
    useStylesInfoTcu,
    useStylesDSM,
    useStylesDTa,
    useStylesAuto,
    useStylesTF,
    useStylesInfoGridItem,
    useStylesDTaCont,
} from "../../../../St/comps/UseStyle";
import ViewListIcon from "@material-ui/icons/ViewList";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import { Mtb } from "../../../../St/comps/vstyle";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import AddIcon from "@material-ui/icons/Add";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
    useStylesLbl,
} from '../../../../St/Reports/UseStyle';
import {
    useStylesUiElemment,
} from "../../../../St/comps/UseStyle";
import ItemsInvTable from "./itemsInvTable";
import ItemsCardList from "./ItemsCardsList";
import Search from "@material-ui/icons/Search";
import ItemDataDialog from "./ItemDataDialog";
import { Info } from "@material-ui/icons";
export default function InvoiceItemsModals(props) {
    // const [infoOpen, setInfoOpen] = useState(false);
    const {
        openCuD,
        handleCloseCuD,
        transition,
        switchState,
        groups,
        groupsSub,
        changSlides,
        subInfo,
        cuRows,
        permiCuCo,
        setting,
        changAutoPricePay,
        valuePricePay,
        changAutoCurrUnits,
        changInfo,
        optionsPricePay,
        optionsCurrUnits,
        checked,
        changSwitch,
        _onDetected,
        changChcked,
        getrowDataCurrencie,
        stElemnt,
        permistionInv,
        rptParams,
        onChangeSearchD,
        AutoOptions,
        isPurches,
        onChangeData,
        onChangeDataA,
        onChangeAutoDataG,
        groupsSubs,
        onChangeAutoDataSub,
        onRowClicks,
        viewHandle,
        groupsOptions,
        isStock,
        valueItemUnits,
        getNewItamsData
    } = props;

    const { t } = useTranslation(["forms"]);

    // const locCurr = useMemo(
    //     () => JSON.parse(localStorage.getItem("premiApp")) || {}
    // );
    const locCurr = {};
    const clasui = useStylesUiElemment();

    const clasSM = useStylesDSM();
    const clasTa = useStylesDTa();
    const clasTaCont = useStylesDTaCont();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const claslbl = useStylesLbl();
    const clasGrdI = useStylesInfoGridItem();
    const classesInfo = useStylesInfoTcu();
    const [viewType, setViewType] = useState(locCurr?.showCurr ? "card" : "table");
    let HideItems = permistionInv?.HIDEITEM == null ? false : permistionInv?.HIDEITEM;
    const [infoData, setInfoData] = useState({ open: false, curr_id: 0, itemName: '', barcode: '', item: false });

    return (
        <Grid item lg={12} md={12} sm={12} xs={12}>
            <Dialog

                fullScreen
                open={openCuD}
                onClose={handleCloseCuD}
                TransitionComponent={transition}
                key={transition ? transition.name : ""}
            >
                {!switchState.tableOrscanBC ? (
                    <Fragment>
                        {locCurr?.statu ? (
                            <DialogTitle
                                className={clasSM.dialogTitleSM}
                                id="customized-dialog-title"
                            >
                                <Tabs
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    aria-label="scrollable auto tabs example"
                                >
                                    {groups.map((group, i) => (
                                        <Tab
                                            key={i}
                                            label={group.name}
                                            onClick={() => changSlides(group.group_id, "Gmain")}
                                        />
                                    ))}
                                </Tabs>
                                <Tabs
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    aria-label="scrollable auto tabs example"
                                >
                                    {groupsSub?.map((groupSub, i) => (
                                        <Tab
                                            key={i}
                                            label={groupSub.name}
                                            onClick={() => changSlides(groupSub?.group_id, "GSub")}
                                        />
                                    ))}
                                </Tabs>
                            </DialogTitle>
                        ) : (
                            <DialogTitle
                                className={clasTa.dialogTitleTa}
                                id="scroll-dialog-title"
                            >
                                {/* قم بإختيار صنف */}
                                {/* <Grid item container>
                                    <Grid item></Grid>
                                </Grid> */}
                                <Grid
                                    item
                                    container
                                    style={{
                                        flex: 1,
                                        justifyContent: "space-evenly",
                                        direction: "rtl",
                                    }}
                                >


                                    <Grid item lg={1} md={1} sm={1} xs={2} >
                                        <Container
                                            maxWidth={false}
                                            style={{
                                                padding: "5px",
                                            }}
                                        >
                                            <IconButton
                                                edge="start"
                                                color="inherit"
                                                aria-label="open drawer"
                                                className={isPurches ? [clasui.buttonPurch] : isStock ? [clasui.buttonSafes] : [clasui.buttonSal]}
                                                onClick={() => viewHandle(rptParams?.group?.id ?? rptParams?.groupS?.id)}
                                            >
                                                <Search />
                                            </IconButton>
                                        </Container>
                                    </Grid>

                                    <Grid item lg={2} md={2} sm={2} xs={5} >
                                        <TextField
                                            type="text"
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            id="id"
                                            label={t("forms:barcode")}
                                            style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50], marginBlock: 5 }}
                                            name="barcodeS"
                                            value={rptParams.barcodeS}
                                            InputProps={{
                                                onKeyDown: (event) => {
                                                    if (event.key === 'Enter') {
                                                        onChangeSearchD(event);
                                                    }
                                                },
                                            }}
                                            onChange={onChangeData("barcodeS")} />
                                    </Grid>

                                    <Grid item lg={3} md={3} sm={3} xs={5} >
                                        <TextField
                                            type="text"
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            id="symbol"
                                            label={t("search_item")}
                                            style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50], marginBlock: 5 }}
                                            name="symbol"
                                            value={rptParams.symbol}
                                            InputProps={{
                                                onKeyDown: (event) => {
                                                    if (event.key === 'Enter') {
                                                        viewHandle();
                                                    }
                                                },
                                            }}
                                            onChange={onChangeDataA("symbol")}
                                        />
                                    </Grid>

                                    <Hidden smUp={["sm"]}>
                                        <Grid item lg={2} md={2} sm={4} xs={8} >
                                            <Autocomplete
                                                value={rptParams.group}
                                                labelPlacement=""
                                                onChange={(event, newValue) => {
                                                    onChangeAutoDataSub("group", newValue)
                                                }}
                                                id="controllable-states-demo"
                                                size="small"
                                                style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50], marginBlock: 5 }}
                                                options={groupsOptions}
                                                disableClearable
                                                getOptionLabel={(option) =>
                                                    typeof option === "string" ? option : option.name
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label={t("product-group")}
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Hidden>

                                    <Hidden only={["xs"]}>
                                        <Grid item lg={3} md={3} sm={3} xs={8} >
                                            <Autocomplete
                                                value={rptParams.group}
                                                labelPlacement=""
                                                onChange={(event, newValue) => {
                                                    onChangeAutoDataG("group", newValue)
                                                }}
                                                id="controllable-states-demo"
                                                size="small"
                                                style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50], marginBlock: 5 }}
                                                disableClearable
                                                options={groupsOptions}

                                                getOptionLabel={(option) =>
                                                    typeof option === "string" ? option : option.name
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label={t("main_group")}
                                                        variant="outlined"
                                                        size="small"

                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item lg={2} md={2} sm={2} xs={6} >
                                            <Autocomplete
                                                value={rptParams.groupS}
                                                labelPlacement=""
                                                onChange={(event, newValue) => {
                                                    onChangeAutoDataSub("groupS", newValue)
                                                }}
                                                id="controllable-states-demo"
                                                size="small"
                                                style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50], marginBlock: 5 }}
                                                options={groupsSubs}
                                                disableClearable
                                                getOptionLabel={(option) =>
                                                    typeof option === "string" ? option : option.name
                                                }
                                                renderInput={(params) => (

                                                    <TextField
                                                        {...params}
                                                        label={t("sub_group")}
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Hidden>
                                    <ToggleButtonGroup
                                        color="primary"
                                        value={viewType}
                                        exclusive
                                        style={{ direction: "ltr" }}
                                        onChange={(event, nextView) => {
                                            if (nextView != null) setViewType(nextView);
                                        }}
                                        aria-label="Platform"
                                    >
                                        <ToggleButton value="card" aria-label="card">
                                            <ViewModuleIcon />
                                        </ToggleButton>
                                        <ToggleButton value="table" aria-label="table">
                                            <ViewListIcon />
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                    <Hidden smDown={["sm"]}>
                                        <Grid item lg={6} md={4}></Grid>
                                    </Hidden>
                                </Grid>
                            </DialogTitle>
                        )}
                    </Fragment>
                ) : (
                    <Fragment>
                        <DialogTitle
                            className={clasSM.dialogTitleSM}
                            id="customized-dialog-title"
                        >
                            ماسح باركود
                        </DialogTitle>
                    </Fragment>
                )}

                <DialogContent className={clasTa.dialogContentTa} dividers>
                    <Grid
                        item
                        container
            /* lg={12} md={12} sm={12} xs={12} */ className={
                            clasTaCont.rootTaCont
                        }
                    >
                        {!switchState.tableOrscanBC ? (
                            <Fragment>
                                {viewType == "card" ? (
                                    <Grid
                                        item
                                        lg={6}
                                        md={7}
                                        sm={12}
                                        xs={12}
                                        className={classesInfo.gridTable}
                                    >
                                        <ItemsCardList
                                            {...{
                                                cuRows,
                                                onRowClicks,
                                                isPurches,
                                                isStock
                                            }}
                                        />
                                    </Grid>
                                ) : (
                                    <Grid
                                        item
                                        lg={6}
                                        md={8}
                                        sm={12}
                                        xs={12}
                                        className={classesInfo.gridTable}
                                    >
                                        <ItemsInvTable
                                            {...{
                                                classesInfo,
                                                cuRows,
                                                permiCuCo,
                                                setting,
                                                Mtb,
                                                stElemnt,
                                                AutoOptions,
                                                onRowClicks,
                                                isPurches,
                                                isStock
                                            }}
                                        />
                                    </Grid>
                                )}
                            </Fragment>
                        ) : (
                            <Fragment>
                                <Grid item lg={6} md={8} sm={12} xs={12}>
                                    <BarcodeScannerComponent
                                        // className="video"
                                        width={300}
                                        facingMode="environment"
                                        // delay
                                        height={300}
                                        onUpdate={(err, result) => {
                                            if (result) _onDetected(result.text);
                                        }}
                                    />
                                    {/* </div> */}
                                </Grid>
                            </Fragment>
                        )}

                        <Grid
                            item
                            lg={6}
                            md={4}
                            sm={12}
                            xs={12}
                            className={classesInfo.gridInfo}
                        >
                            <Grid item className={classesInfo.gridInfoInner}>
                                <Grid item container spacing={1}>
                                    <Grid item lg={8} md={12} sm={7} xs={8}>
                                        <TextField
                                            type="text"
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            id="symbol"
                                            label={t("item-name")}
                                            className={clasTF.rootI}
                                            InputProps={{ className: clasTF.input, readOnly: true }}
                                            name="symbol"
                                            value={subInfo.symbol}
                                        />
                                    </Grid>

                                    <Grid item lg={3} md={7} sm={3} xs={4}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            id="barcode"
                                            label={t("barcode")}
                                            className={clasTF.rootI}
                                            InputProps={{ className: clasTF.input, readOnly: true }}
                                            name="barcode"
                                            value={subInfo.barcode}
                                        />
                                    </Grid>

                                    <Grid item xs={12} className={clasGrdI.rootIGI}></Grid>

                                    <Grid item lg={5} md={4} sm={4} xs={5}>
                                        <Autocomplete
                                            classes={clasAo}
                                            value={valueItemUnits}
                                            onChange={(event, newValue) => {
                                                changAutoCurrUnits(event, newValue);
                                            }}
                                            id="controllable-states-dem"
                                            size="small"
                                            options={optionsCurrUnits}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option?.unitName
                                            }
                                            style={{}}
                                            disableClearable
                                            renderInput={(params) => (
                                                <TextField
                                                    id="valueCurrUnits"
                                                    {...params}
                                                    label={t("unit")}
                                                    variant="outlined"
                                                    size="small"
                                                    InputLabelProps={{ className: claslbl.clor }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item lg={5} md={3} sm={4} xs={4}>
                                        <Autocomplete
                                            classes={clasAo}
                                            value={valuePricePay}
                                            onChange={(event, newValue) => {
                                                changAutoPricePay(newValue);
                                            }}
                                            id="controllable-states-dem"
                                            size="small"
                                            options={optionsPricePay}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option.name
                                            }
                                            style={{}}
                                            // disabled={statu Dis.pricePay}
                                            disabled={setting.cusType == 2 ? true : permistionInv?.DTSP}
                                            disableClearable
                                            renderInput={(params) => (
                                                <TextField
                                                    id="valuePricePay"
                                                    {...params}
                                                    label={setting.priceNM}
                                                    variant="outlined"
                                                    size="small"
                                                    InputLabelProps={{ className: claslbl.clor }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item lg={2} md={5} sm={2} xs={3}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            id="perc"
                                            label={t("packaging")}
                                            className={clasTF.root}
                                            InputProps={{ className: clasTF.input, readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                            name="perc"
                                            value={subInfo.perc}
                                        />
                                    </Grid>

                                    <Grid item lg={2} md={3} sm={2} xs={3}>
                                        <TextField
                                            type="number"
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            id="val1"
                                            label={t("quanity")}
                                            className={clasTF.root}
                                            InputProps={{ className: clasTF.input }}
                                            name="val1"
                                            InputLabelProps={{ shrink: true }}
                                            value={subInfo.val1}
                                            onChange={changInfo("val1")}
                                        />
                                    </Grid>

                                    <Grid item lg={4} md={4} sm={2} xs={4}>
                                        <TextField
                                            type="number"
                                            fullWidth
                                            disabled={!permistionInv.USP}
                                            variant="outlined"
                                            size="small"
                                            id="Price"
                                            label={t("price")}
                                            className={clasTF.root}
                                            InputProps={{ className: clasTF.input }}
                                            name="Price"
                                            pattern="[0-9]*"
                                            value={subInfo.Price}
                                            onChange={changInfo("Price")}
                                        />
                                    </Grid>

                                    <Grid item lg={6} md={5} sm={4} xs={5}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            id="totJust"
                                            label={t("total")}
                                            disabled={!permistionInv.USP}
                                            className={clasTF.root}
                                            InputProps={{ className: clasTF.input, readOnly: false }}
                                            name="totJust"
                                            value={subInfo.totJust}
                                            onChange={changInfo("totJust")}
                                        />
                                    </Grid>

                                    <Grid item lg={1} md={1} sm={1} xs={2}>
                                          {!permistionInv?.HIDEITEMINFO &&
                                        (
                                            <IconButton
                                                color="primary"
                                                aria-label="upload picture"
                                                style={{ maxHeight: "0.7rem" }}
                                                disabled={subInfo?.id>0?false:true}
                                                onClick={(e) => {
                                                    setInfoData({ open: true, curr_id: subInfo.id, itemName: subInfo.symbol, barcode: subInfo.barcode })
                                                }}
                                            >
                                                <Info size={"small"} />
                                            </IconButton>
                                        )}

                                    </Grid>
                                    <Grid item lg={2} md={3} sm={2} xs={3}>
                                        <TextField
                                            type="number"
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            id="val1"
                                            label={t("inventory-balance")}
                                            className={clasTF.root}
                                            disabled={true}
                                            InputProps={{ className: clasTF.input }}
                                            name="rasid"
                                            InputLabelProps={{ shrink: true }}
                                            value={subInfo?.Qtys}
                                        />
                                    </Grid>

                                    <Grid item lg={4} md={4} sm={4} xs={4}>
                                        <TextField
                                            type="number"
                                            fullWidth
                                            disabled={
                                                (permistionInv.APDC === 2 || permistionInv.APDC === 3) &&
                                                    permistionInv.DSOI == 1
                                                    ? false
                                                    : true
                                            }
                                            variant="outlined"
                                            size="small"
                                            id="discount"
                                            label={t("discount-amount")}
                                            className={clasTF.root}
                                            InputProps={{ className: clasTF.input }}
                                            name="discount"
                                            placeholder={"0"}
                                            InputLabelProps={{ shrink: true }}
                                            value={subInfo.discount}
                                            onChange={changInfo("discount")}
                                        />
                                    </Grid>

                                    <Grid item lg={5} md={4} sm={4} xs={3}>
                                        <TextField
                                            type="number"
                                            fullWidth
                                            disabled={
                                                (permistionInv.APDC === 1 || permistionInv.APDC === 3) &&
                                                    permistionInv.DSOI == 1
                                                    ? false
                                                    : true
                                            }
                                            variant="outlined"
                                            size="small"
                                            id="DiscPers"
                                            label={t("discount") + "%"}
                                            className={clasTF.root}
                                            InputProps={{ className: clasTF.input }}
                                            name="DiscPers"
                                            placeholder={"0"}
                                            InputLabelProps={{ shrink: true }}
                                            value={subInfo.DiscPers}
                                            onChange={changInfo("DiscPers")}
                                        />
                                    </Grid>
                                    <Hidden only={["xs"]}>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                                type="text"
                                                id="notes"
                                                label={t("notes")}
                                                className={clasTF.rootI}
                                                InputProps={{ className: clasTF.input, }}
                                                name="notes"
                                                value={subInfo?.notes}
                                                onChange={changInfo("notes")}

                                            />
                                        </Grid>
                                    </Hidden>


                                    <Grid item xs={12} className={clasGrdI.rootIGI}>
                                        <FormLabel className={claslbl.clor}>
                                            {t("value-tax")}
                                        </FormLabel>
                                    </Grid>

                                    <Grid item lg={3} md={6} sm={3} xs={3}>
                                        <TextField
                                            type="text"
                                            fullWidth
                                            disabled={!permistionInv.SVU}
                                            variant="outlined"
                                            size="small"
                                            id="taxperc"
                                            label="%"
                                            className={clasTF.root}
                                            InputProps={{ className: clasTF.input }}
                                            name="taxperc"
                                            placeholder={"0"}
                                            InputLabelProps={{ shrink: true }}
                                            value={subInfo.taxperc}
                                            onChange={changInfo("taxperc")}
                                        />
                                    </Grid>

                                    <Grid item lg={3} md={6} sm={3} xs={5}>
                                        <TextField
                                            type="text"
                                            fullWidth
                                            disabled
                                            variant="outlined"
                                            size="small"
                                            id="taxval"
                                            label={t("value")}
                                            className={clasTF.root}
                                            InputProps={{ className: clasTF.input }}
                                            name="taxval"
                                            placeholder={"0"}
                                            InputLabelProps={{ shrink: true }}
                                            value={subInfo.taxval}
                                            onChange={changInfo("taxval")}
                                        />
                                    </Grid>

                                    <Grid item lg={6} md={12} sm={6} xs={4}>
                                        <Button
                                            fullWidth
                                            autoFocus
                                            variant="contained"
                                            color="primary"
                                            // onClick={getrowDataCurrencie}
                                            onClick={(event) => getrowDataCurrencie("dialog")}
                                            style={{
                                                background: isPurches ? "#008080" : isStock ? "#3f51b5" : colors.green[500],
                                                ...{
                                                    paddingLeft: 0,
                                                    paddingRight: 0,
                                                },
                                            }}
                                            startIcon={<ArrowDownwardIcon />}
                                        >
                                            {" "}
                                            {t("item-download")}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* )} */}
                    </Grid>
                </DialogContent>

                <DialogActions className={clasTa.dialogActionsTa}>
                    {!HideItems && (
                        <Grid
                            item
                            lg={1}
                            md={1}
                            sm={1}
                            xs={2}
                            style={{
                                padding: "0px",
                                color: "#fff",
                                textAlign: "-webkit-center",
                            }}
                        >
                            <IconButton
                                color="inherit"
                                style={{
                                    padding: "10px",
                                    color: "#fff",
                                }}
                                className={isPurches ? [clasui.buttonPurch] : isStock ? [clasui.buttonSafes] : [clasui.buttonSal]}
                                aria-label="open drawer"
                                onClick={getNewItamsData}
                            >
                                <AddIcon />
                            </IconButton>
                        </Grid>
                    )}


                    <Tooltip title={t("automatic")}>
                        <FormControlLabel
                            id="autoOrStaticck"
                            value="autoOrStaticck"
                            name="autoOrStaticck"
                            control={
                                <Checkbox
                                    checked={checked.autoOrStaticck}
                                    onChange={changChcked}
                                    size=""
                                    color="primary"
                                />
                            }
                        // label="أوتوماتيك" labelPlacement="start"
                        />
                    </Tooltip>

                    <Tooltip title={t("stay_on_item_screen")}>
                        <FormControlLabel
                            style={{ fontSize: "0.5rem" }}
                            control={
                                <Switch
                                    checked={switchState.stayInDCurr}
                                    onChange={changSwitch("stayInDCurr")}
                                    id="stayInDCurr"
                                    value="stayInDCurr"
                                    name="stayInDCurr"
                                    label="kdkdk"
                                    inputProps={{ "aria-label": "secondary checkbox" }}
                                />
                            }
                        />
                    </Tooltip>

                    <Button onClick={handleCloseCuD} color="primary">
                        {t("close")}
                    </Button>
                </DialogActions>
            </Dialog>
            {infoData.open &&
                <ItemDataDialog
                    infoData={infoData}
                    setInfoData={setInfoData}
                    PrTy_InPr={setting.PrTy_InPr}
                    isPurches={isPurches}
                    isStock={isStock}
                    isMake={false}
                    permistionInv={permistionInv}
                />
            }

        </Grid>
    );
}
